import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';

import * as appActions from '../actions/appActions';

import Textinput from '../components/textinput';

class ForgotPassword extends React.Component {
    constructor(props) {
		super(props);
	}

    componentDidMount() {
        this.props.actions.showForgotPopup({
            mode: 'forgotPassword'
        });
    }

    render() {

        return (
            <div>
                <h1>Forgot password</h1>
            </div>
        )
    }
}

export default connect(
    state => ({
        appState: state.app
    }),
    dispatch => ({
        actions: bindActionCreators(appActions, dispatch)
    })
)(ForgotPassword);



// WEBPACK FOOTER //
// ./source/screens/ForgotPassword.js